document.addEventListener('DOMContentLoaded', function () {
  function openProductTab(targetId) {
    const desktopTab = document.querySelector(`.tabs-nav-button[data-target="${targetId}"]`);
    const targetPanel = document.getElementById(targetId);
    const accordionButton = targetPanel ? targetPanel.previousElementSibling : null;
    let scrollTarget = targetPanel;

    if (window.innerWidth >= 768 && desktopTab) {
      desktopTab.click();
      scrollTarget = desktopTab;
    } else if (accordionButton && !accordionButton.classList.contains('active')) {
      accordionButton.click();
      scrollTarget = accordionButton;
    } else if (accordionButton) {
      scrollTarget = accordionButton;
    }

    if (scrollTarget) {
      scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function decorateInventoryLeadTimeLinks() {
    document.querySelectorAll('.product__inventory .small-msg').forEach(function (message) {
      const text = message.textContent.trim().toLowerCase();
      if (!text.includes('for approximate lead times') || message.querySelector('.inventory-out-of-stock-tab-link')) {
        return;
      }

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'select-label-info-link inventory-out-of-stock-tab-link';
      button.setAttribute('aria-label', 'Open out of stock lead time information');
      button.title = 'Open out of stock lead time information';
      button.innerHTML = '<span aria-hidden="true">i</span>';

      message.textContent = 'For approximate lead times';
      message.appendChild(button);
    });
  }

  // Accordion behavior for mobile
  document.querySelectorAll('.accordion-button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const content = this.nextElementSibling;

      const isOpen = content && getComputedStyle(content).display !== 'none';

      if (isOpen) {
        content.style.display = 'none';
        this.classList.remove('active');
      } else {
        document.querySelectorAll('.accordion-content').forEach(function (el) {
          el.style.display = 'none';
        });
        document.querySelectorAll('.accordion-button').forEach(function (el) {
          el.classList.remove('active');
        });
        if (content) content.style.display = 'block';
        this.classList.add('active');
      }
    });
  });

  // Tabs behavior for desktop
  document.querySelectorAll('.tabs-nav-button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const target = this.dataset.target;

      document.querySelectorAll('.tabs-nav-button').forEach(function (el) {
        el.classList.remove('active');
      });
      this.classList.add('active');

      document.querySelectorAll('.tabs-content').forEach(function (el) {
        el.classList.remove('active');
        el.style.display = 'none';
      });

      const targetEl = document.getElementById(target);
      if (targetEl) {
        targetEl.classList.add('active');
        targetEl.style.display = '';
      }
    });
  });

  // Set the first tab as active by default on desktop
  if (window.innerWidth >= 768) {
    const firstTab = document.querySelector('.tabs-nav-button');
    if (firstTab) {
      firstTab.classList.add('active');
      const targetEl = document.getElementById(firstTab.dataset.target);
      if (targetEl) {
        targetEl.classList.add('active');
        targetEl.style.display = '';
      }
    }
  }

  decorateInventoryLeadTimeLinks();

  const inventoryObserver = new MutationObserver(decorateInventoryLeadTimeLinks);
  inventoryObserver.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', function (event) {
    const outOfStockLink = event.target.closest('.inventory-out-of-stock-tab-link');
    if (!outOfStockLink) return;

    event.preventDefault();
    openProductTab('outofstockdata');
  });
});
